import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import store from '@/store'
import { axios } from "@/network/network";
import { queryFilterOfLandingsList, queryFilterOfQuizList } from "@/modules/Quiz/metadata";

@Module({
  namespaced: true,
  name: 'quiz',
  store,
  dynamic: true
})
class Quiz extends VuexModule {
  landing_pages: Array<any> = []
  quizzes: Array<any> = []

  @Action({ rawError: true })
  async uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  @Mutation
  setLandingPages(data: any) {
    this.landing_pages = data || []
  }
  @Mutation
  setQuizzes(data: any) {
    this.quizzes = data || []
  }
  
  @Action({rawError: true, commit: "setLandingPages"})
  public async getLandingPages() {
    try {
      let query = queryFilterOfLandingsList()
      const response: any = await axios.post(`SurveysLandingsTemplates/List`, query)
      if (response.data.result !== 'success') {
        return
      } else {
        return Promise.resolve(response.data.data.records)
      }

    } catch (err) {
      return Promise.reject(err.response.data.errors)
    }
  }
  @Action({rawError: true, commit: "setQuizzes"})
  public async getQuizList() {
    try {
      if (this.quizzes && this.quizzes.length > 0) {
        return Promise.resolve(this.quizzes)
      } else {
        let query = queryFilterOfQuizList()
        const response: any = await axios.post(`surveys/list`, query)
        if (response.data.result !== 'success') {
          return
        } else {
          return Promise.resolve(response.data.data.records)
        }
      }

    } catch (err) {
      return Promise.reject(err.response.data.errors)
    }
  }
}

export default getModule(Quiz)
